import React from "react";
import {
	CustomButton,
	CustomIconButton,
	CustomTable,
	CustomTableBody,
	CustomTableCell,
	CustomTableHead,
	CustomTableRow,
	icon,
} from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "./DistributionListTable.module.css";

function formatTerritoryName(territoryName) {
	if (!territoryName) {
		return null;
	}
	return territoryName;
}

export default function DistributionListTable({
	territories = [],
	onAssociate,
	onEdit,
	onDelete,
	onSort,
	isSorted,
	sortDirection,
}) {
	const getSortIcon = () => {
		if (!isSorted) {
			return icon.faSort;
		}
		return sortDirection === "asc" ? icon.faSortUp : icon.faSortDown;
	};

	return (
		<CustomTable stickyHeader>
			<CustomTableHead>
				<CustomTableRow>
					<CustomTableCell className={styles.headerCell}>
						<div className={styles.headerCellContent}>
							<span>{translate("admin.distribution-list.column.territory")}</span>
							<CustomIconButton
								className={styles.sortIcon}
								icon={getSortIcon()}
								iconColor={isSorted ? "var(--color-black)" : "var(--grey-500)"}
								size="sm"
								variant="text"
								onClick={onSort}
							/>
						</div>
					</CustomTableCell>
					<CustomTableCell className={styles.headerCell}>
						{translate("admin.distribution-list.column.email")}
					</CustomTableCell>
					<CustomTableCell className={styles.headerCell} />
				</CustomTableRow>
			</CustomTableHead>
			<CustomTableBody emptyState={translate("common:empty-state.no-data")}>
				{Array.isArray(territories) &&
					territories.map((territory) => (
						<CustomTableRow key={territory.id} hover>
							<CustomTableCell className={styles.territoryCell}>
								<span translate="no">{formatTerritoryName(territory.territoryName)}</span>
							</CustomTableCell>
							<CustomTableCell className={styles.emailCell}>
								{territory.email ? (
									<div className={styles.emailWrapper} translate="no">
										{territory.email}
									</div>
								) : (
									<CustomButton
										color="primary"
										size="sm"
										startIcon={icon.faPlus}
										variant="outlined"
										onClick={() => onAssociate(territory)}
									>
										{translate("admin.distribution-list.associate")}
									</CustomButton>
								)}
							</CustomTableCell>
							<CustomTableCell className={styles.actionsCell}>
								{territory.email && (
									<div className={styles.inlineActions}>
										<CustomIconButton
											icon={icon.faPen}
											size="sm"
											tooltip={translate("common:btn.edit")}
											variant="outlined"
											onClick={() => onEdit(territory)}
										/>
										<CustomIconButton
											icon={icon.faUnlink}
											size="sm"
											tooltip={translate("common:btn.dissociate")}
											variant="outlined"
											onClick={() => onDelete(territory)}
										/>
									</div>
								)}
							</CustomTableCell>
						</CustomTableRow>
					))}
			</CustomTableBody>
		</CustomTable>
	);
}
